<template>
  <div class="min-h-screen bg-grey-90">
    <customs-header :back-route="homeLink" />
    <main class="pb-16">
      <cms-section v-if="eSpots?.['top-of-page']" page-context :section="eSpots?.['top-of-page']" />
      <base-tabs-root v-model="activeId">
        <base-tabs-list class="b-b pb-6 pt-4">
          <div class="mx-a flex items-center justify-around" style="max-width: 48rem">
            <base-tabs-trigger
              v-for="({ id, src, title }) in data.items"
              :key="id"
              class="@hactive:scale-125 text-center duration-500"
              :value="id"
            >
              <span class="relative">
                <transition name="fade">
                  <span
                    v-if="id === activeId"
                    class="absolute right-0 rounded-full p-1 c-white"
                    style="background: #589bc6"
                  >
                    <vf-icon name="check" size="xs" />
                  </span>
                </transition>
                <base-picture alt="" height="80" :lazy="false" :src width="80" />
              </span>
              <span v-if="title" class="mt-1 block title-5 lg:title-3 md:title-4">
                {{ title }}
              </span>
            </base-tabs-trigger>
          </div>
        </base-tabs-list>
        <base-tabs-content v-for="({ id, items }) in data.items" :key="id" class="container" tabindex="-1" :value="id">
          <h1 class="mt-6 pl-1 title-1 font-primary uppercase md:pl-12" style="font-weight: 700">
            {{ data.title }}
          </h1>
          <p v-if="activeId === 'kids-shoes'" class="mt-4 text-center">
            <base-interpolator :content="$t.customs.sizeGuide">
              <template #link="{ args: [message] }">
                <vf-link target="_blank" to="/help/size-charts?category=Kids">
                  {{ message }}
                </vf-link>
              </template>
            </base-interpolator>
          </p>
          <ul class="grid gap-16 py-4 lg:cols-3 md:cols-2">
            <li v-for="({ name, size, src, to }, key) in items" :key class="group relative text-center" :to>
              <base-picture
                alt=""
                class="w-full"
                height="120"
                :lazy="+key > 3"
                :src
                style="padding: 3rem"
                width="196"
              />
              <base-link class="mx-a w-fit f-col group-@hactive:c-brand-3 duration" :to>
                <span class="title-3 uppercase">{{ name }}</span>
                <span v-if="size">{{ size }}</span>
                <span class="absolute-0" />
              </base-link>
            </li>
          </ul>
        </base-tabs-content>
      </base-tabs-root>
      <cms-section v-if="eSpots?.['bottom-of-page']" page-context :section="eSpots?.['bottom-of-page']" />
      <transition name="fade">
        <customs-toolkit
          v-if="customsFlow"
          class="fixed-0 z-overlay"
          :customs-flow
          @close-iframe="$router.push(homeLink)"
          @customs-product-added-to-cart="onAddToCart"
        />
      </transition>
    </main>
  </div>
</template>

<script lang="ts" setup>
definePageMeta({
  layout: false,
  middleware: () => useNuxtApp().$feature.enableCustoms || navigateTo('/')
})
const eSpots = (await useCms().getSections.generic('customize-home')).data.value?.content.sectionsMap
const { data, error } = await useApi().internal.getStaticPage('customs-styles')
if (!isDefined(data)) throw createError({ ...error.value!, fatal: true })

const { homeLink } = useAppConfig().components.customs.header
const cart = useCartStore()
const { DialogMiniCart } = useDialogsStore()
const { $gtm, $feature } = useNuxtApp()
const customsFlow = useRouteQuery('customsFlow')

const activeId = ref(data.value.items[0].id)

const onAddToCart = async () => {
  await cart.get()
  const productItem = cart.items.slice(-1)[0]
  setInteractionOrigin('customizer')
  setGtmCartProductsMap(
    productItem.productId,
    {
      id: productItem.productId,
      masterId: productItem.masterId,
      list: 'Customizer',
      breadcrumbs: [{ label: 'Customs' }],
      category: 'Customizer'
    }
  )
  $gtm.push('cart.onAddToCart', cart, [productItem], { isCartItem: true })
  $gtm.push('cart.onCartUpdate', cart)
  if ($feature.showMiniCartOnAddProduct) {
    DialogMiniCart.open()
  }
}
</script>
